import * as React from 'react';
import {Hint} from './hint/hint';
import './styles.sass';

export interface ITooltipButtonProps {
  visible?: boolean;
  children?: any;
  disabled?: boolean;
  className?: string;
  tooltipType?: string;
  tooltipLabel: string;
  tooltipPlacement?: string;
  onClick?: () => void;
}

export const TooltipButton: React.StatelessComponent<ITooltipButtonProps> = ({
  children,
  onClick,
  visible,
  className,
  tooltipLabel,
  tooltipType,
  tooltipPlacement = 'top',
  disabled = false,
}: ITooltipButtonProps) => (
  <div className={'tooltip-button'}>
    <Hint
      visible={visible}
      disabled={disabled}
      label={tooltipLabel}
      placement={tooltipPlacement}
      type={tooltipType}
    >
      <button
        className={className}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </button>
    </Hint>
  </div>
);
